import React from 'react';
import PropTypes from 'prop-types';
import Feature from '../Feature';

const FeatureList = ({ features, packageId }) => {
    if (!features.length) {
        return null;
    }

    return (
        <ul className="features">
            {
                features.map(({id, ...rest}) => (
                    <Feature key={id} id={id} packageId={packageId} {...rest}/>
                ))
            }
        </ul>
    );
};

FeatureList.defaultProps = {
    features: []
};

FeatureList.propTypes = {
    features: PropTypes.array,
    packageId: PropTypes.number
};

export default FeatureList;
